package com.heelion.farmafreelance.ui

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch

/**
 * Impostazioni → "Elimina account". L'account si chiude subito; i dati vengono cancellati dopo
 * 30 giorni, e accedendo di nuovo prima la richiesta si annulla (vedi EliminazioneAccount.kt nel server).
 */
@Composable
fun SezioneEliminaAccount(viewModel: AuthViewModel, onEliminato: () -> Unit) {
    var chiedi by remember { mutableStateOf(false) }
    var conferma by remember { mutableStateOf<String?>(null) }

    Text(
        text = "Elimina account",
        style = MaterialTheme.typography.titleMedium,
        color = MaterialTheme.colorScheme.error,
        modifier = Modifier.padding(bottom = 8.dp)
    )
    Text(
        "L'account viene chiuso subito e i tuoi dati personali vengono cancellati dopo 30 giorni. " +
            "Se cambi idea, ti basta accedere di nuovo entro quella data.",
        style = MaterialTheme.typography.bodySmall
    )
    Spacer(Modifier.height(8.dp))
    OutlinedButton(
        onClick = { chiedi = true },
        colors = ButtonDefaults.outlinedButtonColors(contentColor = MaterialTheme.colorScheme.error)
    ) { Text("Elimina il mio account") }

    if (chiedi) {
        EliminaAccountDialog(
            viewModel = viewModel,
            onFatto = { messaggio -> chiedi = false; conferma = messaggio },
            onAnnulla = { chiedi = false }
        )
    }
    // Il token non vale più: chiudendo il messaggio l'utente esce e torna alla schermata di accesso.
    conferma?.let { messaggio ->
        val esci = { conferma = null; viewModel.logout(); onEliminato() }
        AlertDialog(
            onDismissRequest = esci,
            title = { Text("Account chiuso") },
            text = { Text(messaggio) },
            confirmButton = { Button(onClick = esci) { Text("OK") } }
        )
    }
}

@Composable
private fun EliminaAccountDialog(viewModel: AuthViewModel, onFatto: (String) -> Unit, onAnnulla: () -> Unit) {
    var password by remember { mutableStateOf("") }
    var errore by remember { mutableStateOf<String?>(null) }
    var isLoading by remember { mutableStateOf(false) }
    val scope = rememberCoroutineScope()

    AlertDialog(
        onDismissRequest = onAnnulla,
        title = { Text("Eliminare l'account?") },
        text = {
            Column {
                Text(
                    "Profilo, preferiti, avvisi e notifiche verranno cancellati. I turni già svolti restano " +
                        "alle farmacie senza il tuo nome. Scrivi la password per confermare.",
                    style = MaterialTheme.typography.bodySmall
                )
                Spacer(Modifier.height(8.dp))
                CampoPassword(value = password, onValueChange = { password = it }, label = { Text("Password") }, modifier = Modifier.fillMaxWidth())
                errore?.let { Text(it, color = MaterialTheme.colorScheme.error, style = MaterialTheme.typography.bodySmall) }
            }
        },
        confirmButton = {
            Button(
                enabled = !isLoading && password.isNotBlank(),
                colors = ButtonDefaults.buttonColors(containerColor = MaterialTheme.colorScheme.error),
                onClick = {
                    isLoading = true
                    errore = null
                    scope.launch {
                        val esito = viewModel.eliminaAccount(password)
                        isLoading = false
                        if (esito.success) onFatto(esito.message ?: "Richiesta ricevuta.")
                        else errore = esito.message ?: "Non è stato possibile eliminare l'account."
                    }
                }
            ) { Text("Elimina") }
        },
        dismissButton = { TextButton(onClick = onAnnulla) { Text("Annulla") } }
    )
}
